export default {
  CareQuilt: 'CareQuilt',
  Title: 'Profile Not Available',
  Description: 'Sorry, this caregiver\'s profile is currently unavailable. Please check back later or contact support if you believe this is an error.',
  BackToCaregiverList: 'Back to My Caregivers',
};
